import { useCallback, useEffect } from 'react'
import useAxiosPrivate from './useAxiosPrivate'
import useFetchFunction from './useFetchFunction'
import { API_URL } from '../api/constants'

export function useGlobalConfigApi(pageNo = 0, pageSize = 1000) {
  const axiosPrivate = useAxiosPrivate()
  const [isLoading, error, data, fetchGlobalConfig] = useFetchFunction()

  const refetch = useCallback(
    (axiosInstance = axiosPrivate) => {
      fetchGlobalConfig({
        axiosInstance,
        path: `${API_URL.GLOBAL_CONFIG}?pageNo=${pageNo}&pageSize=${pageSize}`,
      })
    },
    [axiosPrivate, fetchGlobalConfig, pageNo, pageSize]
  )

  useEffect(() => {
    refetch(axiosPrivate)
    // eslint-disable-next-line
  }, [axiosPrivate])

  return { data, isLoading, error, refetch }
}

export default useGlobalConfigApi
